window.Popper = require("popper.js").default;

window.$ = window.jQuery = require("jquery");

window._ = require("lodash");

require("bootstrap");

require("./vendor/fontawesome-all.js");

window.baseUrl = process.env.API_URL;
window.loginUrl = window.baseUrl + "/login";
window.logoutUrl = window.baseUrl + "/logout";
window.currentUserUrl = window.baseUrl+ "/current_user";

window.portalBaseUrl = process.env.FRONTEND_URL;

window.axios = require("axios");
window.axios.defaults.baseURL = window.baseUrl;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.withCredentials = true;

window.d3 = require("d3");

// Using font-awesome 5 icons for datetimepicker
window.$.extend(true, window.$.fn.datetimepicker.defaults, {
  icons: {
    time: 'far fa-clock',
    date: 'far fa-calendar',
    up: 'fas fa-arrow-up',
    down: 'fas fa-arrow-down',
    previous: 'fas fa-chevron-left',
    next: 'fas fa-chevron-right',
    today: 'fas fa-calendar-check',
    clear: 'far fa-trash-alt',
    close: 'far fa-times-circle'
  }
});



// WEBPACK FOOTER //
// ./src/bootstrap.js